// react-pdf's default config loads its worker from unpkg.com which is
// CORS-blocked in many environments. In demo mode we serve the worker
// bundled by Vite from the same origin instead.
//
// Several other modules in the repo also set `pdfjs.GlobalWorkerOptions
// .workerSrc = "//unpkg.com/..."` at their own module load time
// (libs/react-file-viewer + bw-react-invoice/upload-invoice). Those run
// lazily when the Invoice Detail page mounts, so they would overwrite our
// local URL. We therefore freeze the property — late writes silently
// become no-ops.
import pdfWorkerUrl from "pdfjs-dist/build/pdf.worker.min.mjs?url";
import { pdfjs } from "react-pdf";

let installed = false;

export function installDemoPdfWorker() {
  if (installed) return;
  installed = true;
  Object.defineProperty(pdfjs.GlobalWorkerOptions, "workerSrc", {
    configurable: true,
    enumerable: true,
    get() {
      return pdfWorkerUrl;
    },
    set() {
      // Ignored — keeps later modules from rerouting to unpkg.
    },
  });
  // eslint-disable-next-line no-console
  console.info("[demo] pdfjs worker pinned to local bundle", pdfWorkerUrl);
}
